// extracted by mini-css-extract-plugin
var _1 = "QuizRowStyle-module__complete-quiz___oEgDK";
var _2 = "QuizRowStyle-module__complete-quiz___oEgDK";
var _3 = "QuizRowStyle-module__quiz___ykRs2";
var _4 = "QuizRowStyle-module__quiz-name___afc35";
var _5 = "QuizRowStyle-module__quiz-section___oKp3A";
var _6 = "QuizRowStyle-module__quiz-name___afc35";
var _7 = "QuizRowStyle-module__quiz-section___oKp3A";
var _8 = "QuizRowStyle-module__tick___FiUHC";
export { _1 as "complete-quiz", _2 as "completeQuiz", _3 as "quiz", _4 as "quiz-name", _5 as "quiz-section", _6 as "quizName", _7 as "quizSection", _8 as "tick" }
